import { makeStyles } from "components/providers/makeStyles";

export const useTakeoverDialogStyles = makeStyles((theme) => ({
    title: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: theme.spacing(1),
    },
    dialogContent: {
        paddingTop: 0,
        paddingBottom: 0,
    },
}));
